import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatSliderModule } from '@angular/material/slider';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { RecaptchaModule } from 'ng-recaptcha-2';
// import { InfiniteScrollModule } from 'angular2-infinite-scroll'; // upgraded to new package after angular 7 upgrade
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { AppComponent } from './components/app/app.component';
import { FooterComponent } from './components/app/footer.component';
import { RouteNotFoundComponent } from './components/app/route-not-found.component';
import { BannerComponent } from './components/banner/banner.component';
import { FootnoteDirective } from './components/footnotes/footnote.directive';
import { FootnoteService } from './components/footnotes/footnote.service';
import { FootnotesComponent } from './components/footnotes/footnotes.component';
import { HomeComponent } from './components/home/home.component';
import { MapComponent } from './components/maps/healthcarefinder-map.component';
import { MapService } from './components/maps/healthcarefinder-map.service';
import { MarkerExtensionDirective } from './components/maps/marker-extension.directive';
import { PopupMapComponent } from './components/maps/popup-map/popup-map.component';
import { SidebarDetailComponent } from './components/maps/sidebar/sidebar-detail.component';
import { SidebarComponent } from './components/maps/sidebar/sidebar.component';
import { PopupComponent } from './components/popup/popup.component';
import { PersonProfileComponent } from './components/profile/person/person-profile.component';
import { PersonServiceCategoryComponent } from './components/profile/person/person-service-category.component';
import { PlaceDetailComponent } from './components/profile/person/place-detail.component';
import { PersonByServiceCategroyComponent } from './components/profile/place/person-by-service-category.component';
import { PersonDetailComponent } from './components/profile/place/person-detail.component';
import { PlaceProfileComponent } from './components/profile/place/place-profile.component';
import { PlaceServiceCategoryComponent } from './components/profile/place/place-service-category.component';
import { ReportFormComponent } from './components/report-incorrect-details/report-form.component';
import { ReportIncorrectDetailsService } from './components/report-incorrect-details/report-incorrect-details.service';
import { AutocompleteComponent } from './components/search-input/autocomplete.component';
import { MulticolorDropdownComponent } from './components/search-input/multicolor-dropdown.component';
import { SearchInputHelperService } from './components/search-input/search-input-helper.service';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchInputService } from './components/search-input/search-input.service';
import { FilterHelpFormComponent } from './components/search-results/filter-help-form.component';
import { SearchResultDetailComponent } from './components/search-results/search-result-detail.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { AutoCompleteItemNamePipe } from './pipes/autocomplete.pipe';
import {
  PhoneArrayLinkedPipe,
  PhoneLinkedWithDescriptionPipe,
  PhoneNoSpacesPipe,
  WebAddressPipe,
} from './pipes/string-format.pipe';
import { ErrorHandlingService } from './services/error-handling.service';
import { FilterService } from './services/filter.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { GoogleMapLoaderService } from './services/google-map-loader-service';
import { LocationService } from './services/location.service';
import { ProfileService } from './services/profile.service';
import { SearchService } from './services/search.service';
import { SeoService } from './services/seo.service';
import { StateService } from './services/state.service';
import { StateRxService } from './services/staterx.service';
import { UiService } from './services/ui.service';
/* Upgrade to angular7 resulted in http client needing updating
 * https://angular.io/guide/http
 */

// Declare module
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomeComponent,
    SearchInputComponent,
    AutocompleteComponent,
    SearchResultsComponent,
    PersonProfileComponent,
    PlaceProfileComponent,
    RouteNotFoundComponent,
    PersonServiceCategoryComponent,
    PlaceServiceCategoryComponent,
    PlaceDetailComponent,
    PersonDetailComponent,
    PersonByServiceCategroyComponent,
    SearchResultDetailComponent,
    PhoneNoSpacesPipe,
    PhoneLinkedWithDescriptionPipe,
    PhoneArrayLinkedPipe,
    WebAddressPipe,
    AutoCompleteItemNamePipe,
    MapComponent,
    MarkerExtensionDirective,
    FootnoteDirective,
    FootnotesComponent,
    ReportFormComponent,
    PopupComponent,
    BannerComponent,
    FilterHelpFormComponent,
    PopupMapComponent,
    SidebarComponent,
    SidebarDetailComponent,
    MulticolorDropdownComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    // NgbModule,
    AppRoutingModule,
    GoogleMapsModule,
    InfiniteScrollModule,
    RecaptchaModule,
    BrowserAnimationsModule,
    MatSliderModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HammerModule,
  ],
  providers: [
    SearchInputService,
    SearchInputHelperService,
    StateService,
    StateRxService,
    ErrorHandlingService,
    ProfileService,
    SearchService,
    FilterService,
    UiService,
    GoogleAnalyticsService,
    GoogleMapLoaderService,
    FootnoteService,
    ReportIncorrectDetailsService,
    MapService,
    LocationService,
    SeoService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
